import { useTranslation } from "react-i18next";
import Toast from ".";

export default function UnblockProfileToast() {
  const { t } = useTranslation("im");
  return <Toast iconClass="icon-block" text={t("im.toast-unblock-profile")} />;
}
